const BYTES_PER_MB = 1024 * 1024;

export const isFileSizeValid = (file: File, maxFileSizeMB: number): boolean =>
  file.size <= maxFileSizeMB * BYTES_PER_MB;
